import React from 'react';
import PropTypes from 'prop-types';

import {AppFontDesc} from '../../../app/app-types';
import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar';
import OEResizeObserver from '../../../lib/components/oe-resize-observer';
import {OEStyleSheetTool} from '../../../lib/tools/oe-style-sheet-tool';
import OEToolbox from '../../../lib/tools/oe-toolbox';

export class OETextView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.unitSize = 16;

        this.contentSize = {w: 0, h: 0};
        this.iFrameContentSize = {w: 0, h: 0};

        this.styleSheetTool = null;

        this.state = {
            style: null
        };

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.onUnitSizeResize = this.onUnitSizeResize.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onContentResize = this.onContentResize.bind(this);
        this.onIFrameRef = this.onIFrameRef.bind(this);
    }

    getContentSize()    {
        return this.contentSize;
    }

    getIframeContentSize()    {
        return this.iFrameContentSize;
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.font, this.props.font, true)) {
            this.updateStyleSheetFiles(nextProps);
            this.updateFontStyle(nextProps);
        }
    }

    componentWillUnmount()  {
        this.setCompId(null);
        this.styleSheetTool = null;
    }

    onConnect()  {}

    onRelease()  {}

    setCompId(id)   {
        if(this.compId == id)   return;
        this.compId = id;
        this.updateCompHighlighting();
    }

    updateCompHighlighting()    {
        if(!this.oe.isReady())  return;
        let highlight = this.oe.sharedInterface.getUIControllerHighlightingTooltip();
        if(this.activeCompId) highlight.removeCustomHighlightedComponent(this.activeCompId);
        this.activeCompId = this.compId;
        if(this.activeCompId) highlight.addCustomHighlightedComponent(this.activeCompId);
    }

    updateIFrameContentSize() {
        if(!this.$iFrameDocumentBody)    return;
        let size = {w: this.$iFrameDocumentBody.innerWidth(), h: this.$iFrameDocumentBody.innerHeight()};
        if(OEToolbox.shallowEqual(size, this.iFrameContentSize))   return;
        this.iFrameContentSize = size;
        this.updateStyle();
        if(this.props.onIframeContentSizeChanged) this.props.onIframeContentSizeChanged(this, this.iFrameContentSize);
    }

    updateFontStyle(props)  {
        props = props || this.props;
        if(!this.$iFrameDocumentBody)    return;

        let fontFamily = props.font && props.font.family ? props.font.family : 'Roboto, sans-serif';
        
        this.$iFrameDocumentBody.css({'font-family': fontFamily});

        //
        /*
        // style sheet needs title styles
        let rule = ' font-family: ' + fontFamily + ' ; ';

        this.styleSheetTool.removeRule('font-body');
        this.styleSheetTool.insertRule('font-body', 'body { ' + rule + ' }');
        */
    }

    updateStyleSheetFiles(props)   {
        props = props || this.props;
        if(!this.styleSheetTool)    return;

        let url = window.location.protocol + '//' + window.location.host + window.location.pathname;

        let cssFiles = [
            'fonts/effigos-symbol.css',
            'fonts/roboto/roboto.css'
        ];

        //
        let fontCSSFiles = props.font && Array.isArray(props.font.src) ? props.font.src : (typeof(props.font.src) === 'string' ? [props.font.src] : []);
        fontCSSFiles.forEach(file => { if(!cssFiles.includes(file))   cssFiles.push(file); });
        fontCSSFiles = fontCSSFiles.map(file => url + file)
        
        //
        this.styleSheetTool.removeAllStyleSheetFiles();
        this.styleSheetTool.addStyleSheetFiles(fontCSSFiles);
    }

    updateStyle()   {
        let style = {height: this.iFrameContentSize.h};
        this.setState({style: style});
    }

    updateIFrameBodyFontSize()  {
        if(!this.$iFrameDocumentBody || !this.props.transferFontSize)   return;
        this.$iFrameDocumentBody.css({'fontSize': this.unitSize.toString() + 'px'});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setCompId(null);
            return;
        }

        this.setCompId(null);
    }

    onMouseEnter(e) {
        this.setCompId(e.target.dataset.id);
    }

    onMouseLeave(e) {
        if(this.compId == e.target.dataset.id)  this.setCompId(null);
    }

    onLoad()    {
        if(!this.iFrameRef || !this.iFrameRef.contentWindow)    return;

        if(this.iFrameDocument != this.iFrameRef.contentWindow.document)    {
            this.iFrameDocument = this.iFrameRef.contentWindow.document;
            this.styleSheetTool = new OEStyleSheetTool(this.iFrameDocument);
        }
        
        $(this.iFrameDocument.documentElement).find('span.comp-ref').hover(this.onMouseEnter, this.onMouseLeave);
        this.$iFrameDocumentBody = $(this.iFrameDocument.documentElement).find('body');

        this.updateStyleSheetFiles();
        this.updateFontStyle();
        this.updateIFrameContentSize();
        this.updateIFrameBodyFontSize();
    }

    onUnitSizeResize(sender, size)  {
        if(this.unitSize === size.w) return;
        this.unitSize = size.w;
        this.updateIFrameBodyFontSize();
    }

    onResize() {
        this.updateIFrameContentSize();
    }

    onContentResize(sender, size)   {
        if(OEToolbox.shallowEqual(size, this.contentSize))   return;
        this.contentSize = size;
        if(this.props.onContentSizeChanged) this.props.onContentSizeChanged(this, this.contentSize);
    }

    onIFrameRef(ref)   {
        if(this.iFrameRef === ref) return;
        this.iFrameRef = ref;
        if(!ref && this.iFrameDocument) {
            $(this.iFrameDocument.documentElement).find('span.comp-ref').off('mouseenter mouseleave');

            this.iFrameDocument = null;
            this.$iFrameDocumentBody = null;

            this.styleSheetTool = null;
        }
        this.updateIFrameContentSize();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={'text-view ' + this.props.className} style={this.props.style}>

                    <OEResizeObserver className="unit-size-observer" onResize={this.onUnitSizeResize}/>
                    <OEResizeObserver onResize={this.onResize}/>

                    <CustomScrollbar
                        horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                        verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                        onContentResize={this.onContentResize}
                    >
                        <iframe
                            className="text-element"
                            style={this.state.style}
                            src={this.props.src}
                            ref={this.onIFrameRef}
                            onLoad={this.onLoad}
                        />
                    </CustomScrollbar>

                </div>
            </React.Fragment>
        );
    }
}

OETextView.defaultProps = {
    className:                  '',
    moduleId:                   '',
    font:                       AppFontDesc.defaultFont,
    transferFontSize:           true
};

OETextView.propTypes = {
    className:                  PropTypes.string,
    style:                      PropTypes.object,
    moduleId:                   PropTypes.string,
    src:                        PropTypes.string,
    font:                       AppFontDesc.propTypeDesc,
    transferFontSize:           PropTypes.bool,
    onContentSizeChanged:       PropTypes.func,
    onIFrameContentSizeChanged: PropTypes.func
};

//
export default frefFromRef(connectAppEnv((env) => {
    const config = env.config;
    const ret = {
        font:                   config.font
    };
    return ret;
})(frefToRef(OETextView)));